import { useEffect, useState } from "react";
import { GetListingActivityRequest, GetListingActivityResponse, ListingActivity, ListingActivityType, PayoutType } from "../api/models";
import ListingActivityTable from "./ListingActivityTable";
import Title from "antd/es/typography/Title";
import { notification, TablePaginationConfig } from "antd";
import APIClient from "../api/api";

export interface Props {
    dateStart?: Date;
    dateEnd?: Date;
    source?: string;
    type?: ListingActivityType;
    initialPageSize?: number;
    payoutType?: PayoutType;
    account?: string;
}

const ListingActivityPage = (props: Props) => {
    const [listings, setListings] = useState<GetListingActivityResponse>();
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        pageSize: props.initialPageSize || 10,
        current: 0,
    });

    useEffect(() => {
        loadSalesActivity(pagination);
    }, []);

    async function loadSalesActivity(pagination: TablePaginationConfig) {
        try {
            setListings(undefined);
            const req: GetListingActivityRequest = {};
            if(props.dateStart) req.start = props.dateStart;
            if(props.dateEnd) req.end = props.dateEnd;
            if(props.source) req.source = props.source;
            if(props.type) req.type = props.type;
            if(props.payoutType) req.payoutType = props.payoutType;
            if(props.account) req.account = props.account;
            const resp = await APIClient.getListingActivity({page: (pagination.current||0), pageSize: pagination.pageSize||props.initialPageSize||10}, req);
            setPagination({...pagination, current: resp.currentPage, total: resp.total});
            setListings(resp);
        }
        catch(e) {
            notification.error({message: 'Failed to load at this time.'});
        }
    }

    function onPaginationChange(pagination: TablePaginationConfig) {
        loadSalesActivity(pagination);
    }

    return (
        <ListingActivityTable data={listings?.content} pagination={pagination} onPaginationChange={onPaginationChange}/>
    );
};
export default ListingActivityPage;
